import { ComponentBase } from './ComponentBase';
import { template } from '../utils/TemplateParser';
import { vars } from '../utils/vars';
import { api } from '../utils/api';
import { lang } from '../lang';

export class Hero extends ComponentBase {
    constructor(options = {}) {
        const superOptions = {class: 'hero'};

        if(!vars.pubcalendar.image) {
            const rgb = api.hexToRGB(vars.pubcalendar.color);
            if(rgb) {
                superOptions.style = `--mc-hero-gradient-color: rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 1)`;
            }
        }

        super(superOptions);
        this.query = options.query ?? '';
        this.tag = options.tag ?? [];
    }

    registerEvents() {
        return {
            'click  #calendar-ical-download'  : 'handleICalClick',
            'submit [data-action="event-search"]' : 'handleSearch',
        };
    }

    template() {
        return template`
            <div class="wrapper">
                <div class="hero-text">
                    <h1 id="hero-title">${vars.pubcalendar.title}</h1>
                    <p id="hero-subtitle">${vars.pubcalendar.subtitle}</p>
                    <form data-action="event-search">
                        <input type="search" placeholder="${lang.SearchForEvents}" aria-label="${lang.Search}" value="${this.decode(this.query)}">
                        <button type="submit">${lang.Search}</button>
                    </form>
                </div>
                <div class="export-controls">
                    ${vars.pubcalendar.submitShowLink && vars.pubcalendar.submit ? template`<a href="${this.getRouteURL('event-submission')}" id="submit-event"><i class="icon fas fa-calendar-edit"></i> ${lang.SubmitEvent}</a>` : ''}
                    <a href="${api.getRSSURL({tag: this.tag})}" id="rss-link" target="_blank"><i class="icon fas fa-rss"></i> ${lang.AddToRSS}</a>
                    <a href="${api.getCalendarICS(false)}" id="calendar-ical-download"><i class="icon fas fa-download"></i> ${lang.OutlookICAL}</a>
                </div>
            </div>
            ${imageTemplate()}
        `;
        function imageTemplate(){
            if(!vars.pubcalendar.image) return '';
            return template`<img src="${vars.pubcalendar.image}" alt="${vars.pubcalendar.imageAltText}">`;
        }
    }

    /* Event Handlers */
    handleICalClick(e) {
        if(e.ctrlKey || e.metaKey) return true; // when ctrl or command keys are pressed during click trigger default behavior (open in new tab)
        e.preventDefault();
        api.getCalendarICS();
    }

    handleSearch(e) {
        const query = this.encode(e.target.querySelector('input').value);
        const url = this.getRouteURL(`events/search/${query}`);
        this.triggerRouteChange(url);
        e.preventDefault();
    }
}